<template>
	<div style="position: relative;">
		<el-carousel :interval="tabIndex == 0?5000:2000" arrow="always" height="33vw" @change="change">
			<el-carousel-item v-for="(item, index) in 2" :key="item">
				<img :src="'/home' + (index + 1) + '.png'" style="width: 100%;height: 100%">
			</el-carousel-item>
		</el-carousel>

		<div
			style="padding: 30px 0;background-image: url('/home3.jpg');width: 100%;min-height: 100px;background-size: 100% 100%;background-repeat: no-repeat">
			<el-row type="flex" align="middle" justify="center" style="height: 100%;">
				<div @click="pust(item)" v-for="(item,index) in list" :key="index"
					style="width: 150px;margin: 0 10px;background-color: white;border-radius: 10px;padding: 25px;overflow: hidden;">
					<el-row type="flex" justify="center">
						<img :src=" '/' + item.tag + '.png'" style="width: 40px;height: 40px;" />
					</el-row>
					<div style="font-size: 20px;color: #303133;font-weight: 600;margin-top: 20px;">
						{{item.name}}
					</div>
					<el-popover placement="top-start" :title="item.name" width="500" trigger="hover"
						:content="item.content">
						<div slot="reference"
							style="font-size: 16px;color: #606266;margin-top: 10px;height: 10vw;text-overflow: ellipsis;overflow: hidden;">
							{{item.content}}
						</div>
					</el-popover>
				</div>
			</el-row>
		</div>
		<div style="position: absolute;top: 0;width: 100%;z-index: 100;">
			<TopBar :info="userinfo" :isHome="true"></TopBar>
		</div>
		<div style="position: absolute;bottom: 0;width: 100%;z-index: 100;">
			<el-row type="flex" justify="center">
				<el-link @click="icp()">
					ICP备案号：渝ICP备2024036765号
				</el-link>
			</el-row>
		</div>
	</div>
</template>

<script>
	import TopBar from "@/components/topBar.vue"
	export default {
		name: 'HomePage',
		components: {
			TopBar,
		},
		data() {
			return {
				list: [{
						"name": "考研面试",
						"content": "",
						"tag": "考研",
						"page": "graduate",
					},
					{
						"name": "校招面试",
						"content": "",
						"tag": "校招",
						"page": "school",
					},
					{
						"name": "社招面试",
						"content": "",
						"tag": "社招",
						"page": "social",
					},
					{
						"name": "教师面试",
						"content": "",
						"tag": "教师",
						"page": "teacher",
					},
					{
						"name": "公考面试",
						"content": "",
						"tag": "公考",
						"page": "public",
					}
				],
				tabIndex: 0,
				userinfo: {}
			}
		},
		created() {
			this.getInfo();
			this.getConfig();
		},
		methods: {
			icp() {
				window.location.href = 'https://beian.miit.gov.cn/#/Integrated/recordQuery';
			},
			pust(item) {
				let token = localStorage.getItem("token")
				if (token == undefined) {
					this.$message({
						message: '请在右上角注册，可以免费试用',
						type: 'error',
						offset: window.screen.height / 3
					});
				} else {
					this.$router.push({
						name: item.page
					})
				}
			},
			change(e) {
				this.tabIndex = e;
			},
			async getInfo() {
				let token = localStorage.getItem("token")
				if (token != undefined) {
					const response = await this.http.get("/api/userinfo")
					if (response.data.status == 0) {
						localStorage.setItem("userinfo", JSON.stringify(response.data.data))
						this.userinfo = response.data.data
						// this.$store.commit("saveUserinfo", response.data.data);
					}
				}
			},
			getConfig() {
				this.http.get("/config/getConfig?tag=home").then(response => {
					if (response.data.status == 0) {
						for (let i = 0; i < response.data.data.length; i++) {
							for (let j = 0; j < this.list.length; j++) {
								if (this.list[j].name == response.data.data[i].name) {
									this.list[j].content = response.data.data[i].content
									break;
								}
							}
						}
					}
				})
			}
		}
	}
</script>

<style>
	.el-dropdown-link {
		cursor: pointer;
	}
</style>